export { DealsLink } from './DealsLink'
export type { DealsLinkProps } from './DealsLink'
